<template>
  <ExternalList
      :endpoint="'/api/v2/portal-companies'"
      :endpoint-filters="{company_id: company.id}"
      :headlines="headlines"
      :checkbox-column-width="2"
      :button-column-width="2"
      :can-update="() => true"
      :can-destroy="() => true"
      @show="portalCompany => $router.push(getUrl(portalCompany))"
  >
    <template v-slot:default="{ row: portalCompany }">
      <td>
        <router-link :to="getUrl(portalCompany)">
          {{ portalCompany.attributes.portal_name }}
        </router-link>

        <span v-if="portalCompany.attributes.is_editorial" class="label label-info">
          Editorial
        </span>

        <span v-if="portalCompany.attributes.has_active_partnership" class="label label-success">
          Partner
        </span>
      </td>

      <td>
        <router-link v-if="portalCompany.attributes.user_id" :to="'/users/' + portalCompany.attributes.user_id">
          {{ portalCompany.attributes.user_full_name }}
        </router-link>
      </td>

      <td>
        {{ portalCompany.attributes.legacy_reference }}
      </td>

      <td>
        {{ portalCompany.attributes.path }}
      </td>
    </template>
  </ExternalList>
</template>

<script>
import ExternalList from '../../Panels/Lists/External'

export default {
  components: {ExternalList},

  props: {
    company: {
      required: true
    }
  },

  data() {
    return {
      editing: null
    }
  },

  computed: {
    headlines() {
      return [
        {width: 5, text: 'Portal'},
        {width: 5, text: 'User'},
        {width: 5, text: 'Legacy Reference'},
        {width: 5, text: 'Path'},
      ]
    }
  },

  methods: {
    show(portalCompany) {
      this.editing = portalCompany

      this.$nextTick(() => $('#edit-portal-company-modal').modal('show'))
    },

    getUrl(portalCompany) {
      return '/companies/' + this.company.id + '/portals/' + portalCompany.id
    }
  }
}
</script>
